<script setup lang="ts">
defineProps<{
  title: String
}>()
</script>

<template>
  <section class="about-club section section_border-line">
    <h2 class="about-club__title section__title">
      {{ $t('page.product.body.title') }}
      <br>
      {{ title }}
    </h2>
    <slot></slot>
  </section>
</template>

<style scoped lang="scss">
@import '@boats/ui/styles/config';

.section {
  padding: 14px 0 40px 0;
  display: grid;
  grid-template-columns: 1fr;

  @include media-breakpoint-up(lg) {
    grid-template-columns: 290px 1fr;
    grid-column-gap: 40px;
    padding: 63px 0;
    border-top: 3px solid $black;
  }

  &_border-line {
    border-top: 2px solid $black;

    @include media-breakpoint-up(lg) {
      border-top: 3px solid $black;
    }
  }

  &__title {
    width: 100%;
    @include h2-barlow;

    @include media-breakpoint-up(lg) {
      width: 270px;
    }
  }
}
</style>
